<template>
  <v-container fluid class="px-5 pt-3">
    <v-row class="pa-3" align='center'>
      <span class="title font-weight-bold">{{ $t('employees.employees') }}</span>
      <v-spacer></v-spacer>
      <v-btn color="primary" elevation="0" small class="text-capitalize font-weight-bold" style="border-radius: 5px;" :to="{name: 'NewEmployee'}" >
        <v-icon left small>mdi-plus</v-icon>
        {{ $t('employees.employee') }}
      </v-btn>
    </v-row>
    <!-- <base-page-title title="Cadastro de Employeee">
      <template v-slot:actions>
        <f-btn alt_label="Cadastrar de Employeee" alt_icon="mdi-plus"></f-btn>
      </template>
    </base-page-title> -->
    <employee-list class="mt-5"></employee-list>

    <router-view></router-view>
  </v-container>
</template>

<script>
export default {
  name: 'EmployeeListPage',
  components: {
    EmployeeList: () => import('@/components/employee/EmployeeList.vue'),
  },
}
</script>

<style scoped>

</style>